import Dialog from '@/components/Dialog';
import ModelType from '@/lib/constants/challengeModel/ModelType.enum';
import { IconButton } from '@mui/material';
import { useState } from 'react';
import { InfoOutlined as InfoIcon } from '@mui/icons-material';
import FormattedMessageWithChallengeNaming from '@/components/FormattedMessageWithChallengeNaming';
import { FormattedMessage } from 'react-intl';

type ModelSelectInfoProps = {
  variant: ModelType;
};

const ModelSelectInfo = ({ variant }: ModelSelectInfoProps) => {
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);

  return (
    <>
      <IconButton size="small" onClick={() => setInfoDialogOpen(true)}>
        <InfoIcon />
      </IconButton>
      <Dialog open={infoDialogOpen} onClose={() => setInfoDialogOpen(false)}>
        <Dialog.Title>
          <FormattedMessage id="portfolio.create_portfolio_item.model_select.info_dialog.title" />
        </Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedMessageWithChallengeNaming
              id={`portfolio.create_portfolio_item.model_select.info_dialog.text.${variant === ModelType.CHALLENGE ? 'challenge' : 'task'}`}
            />
          </Dialog.ContentText>
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.DoneButton onClick={() => setInfoDialogOpen(false)} />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default ModelSelectInfo;
